// Import dependencies
import React from 'react';
import axios from 'axios';
import cookie from 'js-cookie';
import { tokenize } from '../../../../../helper';
import { Modal, Button } from 'react-bootstrap';

// Import config
import config from '../../../../../configs/config.json';
const API_URL = config.API_URL;
const ADMIN_API_URL = API_URL + '/admin';
const SETTINGS_URL = ADMIN_API_URL + '/settings';

const MESSAGE_LIMIT = 1600;

class LandingPageSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            headerHTML: '',
            headerHTMLModified: false,
            newRecordings: '',
            newRecordingsModified: false,
            courseCatalog: [],
            showSubmitHeaderHTMLModal: false,
            showSubmitNewRecordingsMessageModal: false,
            bannerFile: null,
            bannerUploadSuccess: false,
            bannerUploadResponse: '',
            modalSuccess: false,
            modalMessage: ''
        }
    }

    componentDidMount = () => {
        axios.get(`${API_URL}/landing/all`)
            .then(response => {
                var payload = response.data;
                console.log("Landing Meta: ", payload);

                if (payload.success) {
                    this.setState({
                        newRecordings: payload.newRecordings.text,
                        courseCatalog: payload.courseCatalog,
                        headerHTML: payload.headerHTML
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    updateHeaderHTML = (event) => {
        var newValue = event.target.value;

        this.setState({ headerHTML: newValue, headerHTMLModified: true });
    }

    submitHeaderHTML = () => {
        console.log("Submit to back-end")

        axios.patch(`${SETTINGS_URL}/landing/headerHTML`, tokenize({ headerHTML: this.state.headerHTML }))
            .then(response => {
                var payload = response.data;
                console.log(payload);

                if (payload.success) {
                    this.setState({ modalMessage: "Successfully updated header HTML.", modalSuccess: true });
                } else {
                    this.setState({ modalMessage: "Failed to update header HTML.", modalSuccess: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ modalMessage: "Failed to update header HTML.", modalSuccess: false });
            })
    }

    updateNewRecordingsField = (event) => {
        var newValue = event.target.value;

        this.setState({ newRecordings: newValue, newRecordingsModified: true });
    }

    updateNewCourseDescription = (event) => {
        var newValue = event.target.value;
        console.log(newValue)

        this.setState({ newCourseDescription: newValue });
    }

    handleModalClose = () => {
        this.setState({
            showSubmitHeaderHTMLModal: false,
            showSubmitNewRecordingsMessageModal: false,
            modalMessage: '',
            bannerUploadResponse: ''
        })
    }

    submitNewRecordingsText = () => {
        // Submit the text entered to the back-end server
        axios.patch(`${SETTINGS_URL}/landing/newRecordings`, tokenize({ newMessage: this.state.newRecordings }))
            .then(response => {
                var payload = response.data;
                console.log(payload);

                if (payload.success) {
                    this.setState({ modalMessage: "Successfully updated message.", modalSuccess: true });
                } else {
                    this.setState({ modalMessage: "Failed to update message.", modalSuccess: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ modalMessage: "Failed to update message.", modalSuccess: false });
            })
    }

    showModal = (type) => {
        var state = this.state;
        state[type] = true;

        this.setState(state);
    }


    submitCourseInfo = (index) => {
        console.log("submitCourseInfo for index: ", index)
        var courseInfo = this.state.courseCatalog[index];
        var file = this.state.courseCatalog[index].file;


        const formData = new FormData();
        formData.append('file', file);
        formData.append('ID', courseInfo.ID);
        formData.append('description', courseInfo.description);
        formData.append('sortOrder', courseInfo.sortOrder);
        formData.append('display', courseInfo.display);

        console.log("FORM DATA", courseInfo);

        axios.patch(`${SETTINGS_URL}/landing/course`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    token: cookie.get('token')
                }
            }
        )
            .then(response => {
                var payload = response.data;
                console.log(payload);
                var courseCatalog = this.state.courseCatalog;

                if (payload.success) {
                    if (payload.fileName) {
                        courseInfo.link = payload.fileName;
                    }

                    courseInfo.serverStatus = true;
                    courseInfo.serverMessage = payload.message;
                    courseCatalog[index] = courseInfo;
                    this.setState({ courseCatalog });
                } else {

                    courseInfo.serverStatus = false;
                    courseInfo.serverMessage = payload.message;
                    courseCatalog[index] = courseInfo;
                    this.setState({ courseCatalog });
                }
            })
            .catch(error => {
                console.log(error);
            })

    }

    renderModalResponse = () => (
        // Render the resonse from the server in the modal
        <div>
            <div className={(this.state.modalSuccess) ? 'alert alert-success' : 'alert alert-danger'}>
                {this.state.modalMessage}
            </div>
            <button className='btn btn-secondary' onClick={() => setTimeout(this.handleModalClose, 500)}>Done</button>
        </div>
    )

    handleBannerFileChange = (event) => {
        const file = event.target.files[0];
        this.setState({ bannerFile: file });
    }

    submitBanner = () => {
        const formData = new FormData();
        var file = this.state.bannerFile;
        formData.append('file', file);

        axios.patch(`${SETTINGS_URL}/landing/banner`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    token: cookie.get('token')
                }
            }
        )
            .then(response => {
                var payload = response.data;
                console.log(payload);
                if (payload.success) {
                    this.setState({ bannerUploadSuccess: true, bannerUploadResponse: 'Successfully uploaded banner.' });
                } else {
                    this.setState({ bannerUploadSuccess: false, bannerUploadResponse: 'Failed to upload banner. Verify image format is .jgp, .gif, or .png' });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ bannerUploadSuccess: false, bannerUploadResponse: 'Failed to upload banner. Verify image format is .jgp, .gif, or .png' });
            })
    }

    handleFileChange = (index, event) => {
        // Append new photo to course in state
        const file = event.target.files[0];

        var courseCatalog = this.state.courseCatalog;
        courseCatalog[index].file = file;
        courseCatalog[index].modified = true;
        this.setState({ courseCatalog });
    }

    handleCourseDataChange = (index, field, event) => {
        // Update the course data
        var newValue = event.target.value;

        var courseCatalog = this.state.courseCatalog;
        courseCatalog[index][field] = newValue;
        courseCatalog[index].modified = true;

        this.setState({ courseCatalog });
    }

    handleCourseToggleChange = (index, event) => {
        var newValue = event.target.checked;
        var courseCatalog = this.state.courseCatalog;
        courseCatalog[index]["display"] = newValue === true ? 1 : 0;
        courseCatalog[index].modified = true;
        console.log(courseCatalog);
        this.setState({ courseCatalog });
    }

    renderCourseEntry = (entry, index) => {
        // Render the editable course entry

        var classNumber = index + 1;

        return (
            <div className='inputFormTopMargin' key={index}>
                <div className='row'>
                    <div className='col-8'>
                        <h4>Course #{classNumber}</h4>
                    </div>
                    <div className='col-4'>
                        <label htmlFor={`course${index}SortOrder`}>Sorting Order</label>
                        <input id={`course${index}SortOrder`} step='0.1' className='form-control' type='number' value={entry.sortOrder} onChange={(event) => this.handleCourseDataChange(index, 'sortOrder', event)} />
                    </div>
                </div>
                <img className='mx-auto d-block inputFormTopMargin' style={{ width: '25vw', textAlign: 'center' }} src={`/images/${entry.link}`} alt={`Course #${classNumber} Thumbnail`} />
                <textarea className="form-control inputFormTopMargin" id="" rows="4" placeholder='Enter course description...' value={this.state.courseCatalog[index].description} onChange={(event) => this.handleCourseDataChange(index, 'description', event)}></textarea>
                <div class="d-flex justify-content-between">
                    <span><span className={(entry.description.length > MESSAGE_LIMIT) ? 'redText' : ''}>{entry.description.length}</span>/{MESSAGE_LIMIT}</span>
                    <div class="custom-control custom-switch">
                        <input name={`displayCourse${index}`} type="checkbox" class="custom-control-input" id={`displayCourse${index}`} checked={this.state.courseCatalog[index].display} onChange={(event) => this.handleCourseToggleChange(index, event)} />
                        <label class="custom-control-label" for={`displayCourse${index}`}>Show</label>
                    </div>
                </div>
                <form>
                    <div className="form-group">
                        <label htmlFor={`course${classNumber}PhotoUpload`}>Upload Photo</label>
                        <input type="file" accept=".jpg,.gif,.png" className="form-control-file" id={`course${classNumber}PhotoUpload`} onChange={(event) => this.handleFileChange(index, event)} />
                    </div>
                </form>

                {(entry.description.length === 0) ?
                    <div className='alert alert-danger'>
                        <p>Courses without a description will not be shown.</p>
                    </div>
                    :
                    ''
                }

                {(entry.modified) ?
                    <button className='btn btn-primary' onClick={() => this.submitCourseInfo(index)}>Save Course #{classNumber} Info</button>
                    :
                    ''
                }


                {(entry.serverMessage) ?
                    <div className={(entry.serverStatus === true) ? 'alert alert-success inputFormTopMargin' : 'alert alert-danger inputFormTopMargin'}>{entry.serverMessage}</div>
                    :
                    ''
                }

                <hr />

            </div>
        )
    }

    render() {
        return (
            <div>
                <div className='card'>
                    <div className='card-header'>
                        <h3 className='card-title'>Landing Page Settings</h3>
                    </div>

                    <div className='card-body'>

                        <img alt='Landing Page Banner' className='mx-auto d-block inputFormTopMargin' style={{ width: '25vw', textAlign: 'center' }} src={`/images/landing/banner.jpg`} />
                        <label htmlFor='bannerPhotoUpload'>Upload Banner</label>
                        <input type="file" accept=".jpg,.gif,.png" className="form-control-file" id='bannerPhotoUpload' onChange={(event) => this.handleBannerFileChange(event)} />

                        {(this.state.bannerFile === null) ?
                            ''
                            :
                            <button className='btn btn-primary inputFormTopMargin' onClick={this.submitBanner}>Submit Banner Image</button>
                        }


                        {(this.state.bannerUploadResponse !== '') ?
                            <div className={(this.state.bannerUploadSuccess) ? 'alert alert-success inputFormTopMargin' : 'alert alert-danger inputFormTopMargin'}>
                                {this.state.bannerUploadResponse}
                            </div>
                            :
                            ''
                        }
                        <hr />

                        <label htmlFor='headerHTMLInput'>Header HTML</label>
                        <textarea className="form-control" id="headerHTMLInput" rows="6" placeholder='Enter html for header...' value={this.state.headerHTML} onChange={this.updateHeaderHTML}></textarea>
                        <div>
                            <span><span className={(this.state.headerHTML.length > MESSAGE_LIMIT) ? 'redText' : ''}>{this.state.headerHTML.length}</span>/{MESSAGE_LIMIT}</span>
                        </div>


                        {(this.state.headerHTMLModified === true) ?
                            (this.state.headerHTML.length > MESSAGE_LIMIT) ?
                                <button title='Message length exceeded limit' className='btn btn-danger inputFormTopMargin' disabled>Update Header HTML</button>
                                :
                                <button className='btn btn-primary inputFormTopMargin' onClick={() => this.showModal('showSubmitHeaderHTMLModal')}>Update Header HTML</button>
                            :
                            ''
                        }

                        { // If message length exceeds limit do not allow them to submit

                        }

                        <hr />

                        <label htmlFor='newRecordingsMessage'>Mid-Page HTML Block</label>
                        <textarea className="form-control" id="newRecordingsMessage" rows="4" placeholder='Enter published recordings...' value={this.state.newRecordings} onChange={this.updateNewRecordingsField}></textarea>
                        <div>
                            <span><span className={(this.state.newRecordings.length > MESSAGE_LIMIT) ? 'redText' : ''}>{this.state.newRecordings.length}</span>/{MESSAGE_LIMIT}</span>
                        </div>

                        { // If message length exceeds limit do not allow them to submit
                            (this.state.newRecordingsModified) ?
                                (this.state.newRecordings.length > MESSAGE_LIMIT) ?
                                    <button title='Message length exceeded limit' className='btn btn-danger inputFormTopMargin' disabled>Update Mid-Page HTML</button>
                                    :
                                    <button className='btn btn-primary inputFormTopMargin' onClick={() => this.showModal('showSubmitNewRecordingsMessageModal')}>Update Mid-Page HTML</button>

                                :
                                ''
                        }


                        <hr />

                        {
                            this.state.courseCatalog.map((course, index) => {
                                return this.renderCourseEntry(course, index)
                            })
                        }
                    </div>

                </div>

                <Modal show={this.state.showSubmitHeaderHTMLModal} onHide={this.handleModalClose} >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Header HTML</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        Confirm you want to change the header's HTML to:
                        <br /><br />
                        {this.state.headerHTML.split('\n').map((line, index) => {
                            return <div key={index}>{line}<br /></div>
                        })}

                    </Modal.Body>
                    <Modal.Footer>
                        {(this.state.modalMessage === '') ?
                            <div>
                                <Button variant='secondary' onClick={this.handleModalClose}>
                                    Cancel
                                </Button>
                                <Button variant="warning" onClick={this.submitHeaderHTML}>
                                    Proceed
                                </Button>
                            </div>
                            :
                            this.renderModalResponse()
                        }

                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showSubmitNewRecordingsMessageModal} onHide={this.handleModalClose} >
                    <Modal.Header closeButton>
                        <Modal.Title>Change Mid-Page HTML Block</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        Confirm you want to change the Mid-Page HTML Block:
                        <br /><br />
                        {this.state.newRecordings.split('\n').map((line, index) => {
                            return <div key={index}>{line}<br /></div>
                        })}

                    </Modal.Body>
                    <Modal.Footer>
                        {(this.state.modalMessage === '') ?
                            <div>
                                <Button variant='secondary' onClick={this.handleModalClose}>
                                    Cancel
                                </Button>
                                <Button variant="warning" onClick={this.submitNewRecordingsText}>
                                    Proceed
                                </Button>
                            </div>
                            :
                            this.renderModalResponse()
                        }

                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default LandingPageSettings;